import { css, Global } from '@emotion/react';

// AxLLCircular @font-face (+ input font-family) shared by the production app
// shell and the preview shell. `src/styles/global.tsx` sets the body
// font-family to `circularFontFamily` (AxLLCircular, …), but the actual web
// font is only loaded by these @font-face rules — without them a page falls
// back to system fonts. Kept in one place so the app and preview stay in sync.
export const FontFaceGlobal: React.FC = () => (
  <Global
    styles={css`
      input {
        font-family: AxLLCircular, Helvetica, Arial, sans-serif;
      }
      @font-face {
        font-family: AxLLCircular;
        src: url(https://checkout.airwallex.com/fonts/CircularXXWeb/CircularXXWeb-Regular.woff2);
        font-weight: 400;
        font-style: normal;
      }
      @font-face {
        font-family: AxLLCircular;
        src: url(https://checkout.airwallex.com/fonts/CircularXXWeb/CircularXXSub-BoldSubset.woff2);
        font-weight: 500;
        font-style: normal;
      }
    `}
  />
);

export default FontFaceGlobal;
